import constants from "../../constants";
import Avtar from "assets/images/avatar.jpg"

export const ProfilePicViewInput = ({
    file,
    src,
}) => {
    const myFile = file ? URL.createObjectURL(file) : src ? constants?.baseUrl + src : Avtar
    return (
        <div className="mb-3 cursor-pointer">
            <img src={myFile} className="profile-image" />
        </div>
    )
}